import styled, { createGlobalStyle } from "styled-components";


export const RichTextEditorStyles = createGlobalStyle<{ height?: number }>`
  .ProseMirror {
    min-height: ${({ height }) => height ? `${height}px` : '500px'}!important;
    padding: 20px;
    font-size: 16px;
    line-height: 1.6;
  }

  .remirror-editor-wrapper {
    width: 100%;
  }

  .remirror-image-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 2rem auto;
    position: relative;
    background-color: #f3f3f3;
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 16/9;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .remirror-image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: opacity 0.5s ease;
    border-radius: 8px;
    resize: both;
    overflow: auto;
    min-width: 50px;
    min-height: 50px;
    max-width: 100%;
  }

  .remirror-image-resizable-wrapper:hover div:last-child {
    background: rgba(0, 0, 0, 0.8);
  }

  .remirror-image-resizable-wrapper[data-uploading="false"] .progress-badge {
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
  }

  .remirror-image-resizable-wrapper {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    max-width: 600px;
    height: auto;
    resize: both;
    overflow: auto;
    min-width: 100px;
    min-height: 100px;
    margin: 3rem auto;
    border-radius: 8px;
  }

  /* Add spacing for video */
  .remirror-video-wrapper {
    margin: 3rem auto;
  }

  /* Reduce margin for audio and PDF since they're more compact and we have paragraph spacing */
  .remirror-audio-wrapper,
  .remirror-pdf-wrapper {
    margin: 1rem auto;
  }

  /* Add spacing between paragraphs for better content separation */
  .ProseMirror p {
    margin: 1rem 0;
  }


  .ProseMirror,
  .ProseMirror:active, 
  .ProseMirror:focus {
    outline: none!important;
    box-shadow: none!important;
    border: none!important;
  }

  /* Add extra spacing for empty paragraphs that create spacing between media */
  .ProseMirror p:empty {
    min-height: 2rem;
    margin: 1rem 0;
    padding: 0.5rem;
    border: 1px dashed rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    cursor: text;
    display: block;
  }

  /* Style for empty paragraphs to indicate they're text insertion points */
  .ProseMirror p:empty:hover {
    background-color: rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.3);
  }

  /* Add subtle placeholder text for empty paragraphs */
  .ProseMirror p:empty::before {
    content: "Click here to add text...";
    color: rgba(0, 0, 0, 0.4);
    font-style: italic;
    pointer-events: none;
    font-size: 14px;
  }

  /* Add cursor positioning hints for media elements */
  .remirror-image-resizable-wrapper,
  .remirror-video-wrapper,
  .remirror-audio-wrapper,
  .remirror-pdf-wrapper {
    position: relative;
  }



  .remirror-image-wrapper.loading img {
    opacity: 0.6;
    animation: loadingShimmer 1.2s infinite;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 400% 100%;
  }

  @keyframes loadingShimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  .progress-badge {
    position: absolute;
    bottom: 18px;
    right: 18px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 12px;
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .remirror-image-wrapper[data-uploading="false"] .progress-badge {
    opacity: 0;
    transform: translateY(10px);
  }


  
`


export const CharacterCounterWrapper = styled.div`
  font-size: 12px;
  display: flex;
  width: 100%;
  padding: 5px 10px;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  bottom: 57px;
  z-index: 1000;
  background: white;
  border-top: 1px solid #e2e8f0;
  border-radius: 0px;

  @media(min-width: 768px){
    bottom: -80px;
  }
`